// extracted by mini-css-extract-plugin
export var cardHeader = "_fm-1";
export var contentCard = "_fm-0";
export var headerActions = "_fm-3";
export var reorderHandle = "_fm-5";
export var titleArea = "_fm-2";
export var titleAreaWithHandle = "_fm-4";